import { defineStore } from "pinia";
import { computed, ref } from "vue";
import ApiJobs from "@/apis/ApiJobs";
import { useToastsStore } from "./toastsStore";
import { catchable } from "./piniaUtils";

export const useJobsStore = defineStore("jobs", () => {
  const toastsStore = useToastsStore();
  const jobs = ref([]);

  const activeJobs = computed(() =>
    jobs.value.filter(job => ["pending", "processing"].includes(job.status)),
  );

  const getJobs = appId =>
    catchable({
      t: async () => {
        const jobsFetched = await ApiJobs.getJobs(appId);
        jobs.value = Array.isArray(jobsFetched) ? jobsFetched : [];
      },
    });

  const createJob = ({ appId, metrics_period, path_ids, export_type }) =>
    catchable({
      t: async () => {
        const jobParams = {
          ...metrics_period,
          ...(path_ids && { path_ids }),
          ...(export_type && { export_type }),
        };
        await ApiJobs.createJob(appId, jobParams);
        getJobs(appId);
        toastsStore.create({
          type: "success",
          body: "Export in progress, please visit Settings > Download Data to access. May take up to 15 minutes.",
          timeout: 5000,
          bodyTransform: null,
        });
      },
      c: error =>
        toastsStore.create({
          type: "error",
          body: `${error.message}. Visit Settings > Downloads to access.`,
          timeout: 5000,
          bodyTransform: null,
        }),
      loadable: true,
    });

  return { jobs, activeJobs, getJobs, createJob };
});
